// extracted by mini-css-extract-plugin
module.exports =  {"filters":"ayCQkw","stretchVertically":"W37hKK"};